<template>
  <div class="website-index">
    <website-header></website-header>
    <div class="index-top" :style="`background-image:url('${imgURI + '/static/index/bj-min.png'}');`">
      <div class="index-top-bor">
        <div class="display-flex tips-c">侃侃 让世界更懂你！</div>
        <div class="display-flex flex-column tips">
          <div class="bold">MAKE THE WORLD</div>
          <div class="font-weight-100">UNDERSTAND YOU BETTER</div>
        </div>
      </div>
    </div>
    <div class="data-bor">
      <img :src="`${imgURI}/static/index/suju.png`"/>
    </div>
<!--    企业简介-->
    <div class="introduction-bor" :style="`background-image:url('${imgURI + '/static/index/bg21.jpg'}');`">
      <tips :tipsC="`企业简介`" :tipsE="`COMPANY PROFILE`" :paddingTop="120"></tips>
      <div class="introduction-cont">
        公司成立于2011年，总部位于重庆，在深圳、广州等设有分公司及办事处。<br/>
        侃侃致力于为国内的跨境电商卖家提供一站式综合服务，为传统制造型企业出海提供<br/>
        落地的转型升级服务。
      </div>
      <div class="introduction-cont-2">
        与Google、Facebook等社交平台，Amazon、eBay、Wish、Shopee、Lazada等<br/>
        B2C电商平台，Shopify、Shopline等独立站平台密切合作，重点打造覆盖卖家、<br/>
        服务商、供应链和跨境平台的跨境电商生态圈。
      </div>
      <div class="introduction-more" @click="goMore">
        查看更多 <i class="el-icon-arrow-right"></i>
      </div>
    </div>
<!--    服务范围-->
    <div class="service-bg">
      <div>
        <div class="website-index-tips text-center">
          <span class="tips-about bold">SERVICE AREA</span>
        </div>
        <div class="website-index-tips-c text-center">服务范围<span class="tips-block"></span></div>
      </div>
      <div class="margin-center service-card">
        <el-carousel :interval="4000" type="card" height="400px">
          <el-carousel-item v-for="(item, index) in serviceCardList" :key="index">
            <div class="service-item">
              <img :src="`${imgURI}/static/index/${item.bg}`"/>
              <div>
                <div class="title-bor">
                  <div class="font-18 color-0685D9">{{item.title}}</div>
                  <div class="font-11 color-87898A">{{item.titleE}}</div>
                </div>
                <div class="content-bor color-979797 font-12">
                  {{item.content}}
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
<!--合作伙伴-->
    <div>
      <div class="website-index-tips text-center">
        <span class="tips-about bold">PARTNER</span>
      </div>
      <div class="website-index-tips-c text-center">合作伙伴<span class="tips-block"></span></div>
    </div>
    <div class="lg-bor text-center">
      <img :src="`${imgURI}/static/index/hzhb.png`" />
    </div>
<!--    <div class="enterprise def-width display-flex justify-content-between margin-center">-->
<!--      <div class="introduction">-->
<!--        <div class="introduction">-->
<!--          <div class="display-flex align-items-center">-->
<!--            <span class="introduction-c font-24">企业目标</span>-->
<!--            <span class="font-12 color-D2D2D2">ENTERPRISE GOALS</span>-->
<!--          </div>-->
<!--          <div class="introduction-line"></div>-->
<!--          <div class="introduction-cont font-14 color-646464 letter-spacing-2">-->
<!--            <div>-->
<!--              成为跨境出口电商行业内TOP的企业孵化、培训及服务平台。-->
<!--              <div class="enterprise-msg">打造跨境出口电商行业内规模最大且不断追求价值实现的商业共同体。</div>-->
<!--              助力至少1000家国内传统制造型企业出海，帮助至少1000家亿级跨境电商企业实现-->
<!--              跨越式发展。-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div>-->
<!--        <img :src="`${imgURI}/static/index/mubiao.png`"/>-->
<!--      </div>-->
<!--    </div>-->
<!--    <ul class="content-num def-width display-flex justify-content-between margin-center text-center">-->
<!--      <li>-->
<!--        <img :src="`${imgURI}/static/index/IC1.png`"/>-->
<!--        <div class="text-c font-18">品牌<span class="bold">涉猎平台</span></div>-->
<!--        <div class="font-28 bold">10+</div>-->
<!--      </li>-->
<!--      <li>-->
<!--        <img :src="`${imgURI}/static/index/IC2.png`"/>-->
<!--        <div class="text-c font-18">稳定<span class="bold">合作伙伴</span></div>-->
<!--        <div class="font-28 bold">500+</div>-->
<!--      </li>-->
<!--      <li>-->
<!--        <img :src="`${imgURI}/static/index/IC3.png`"/>-->
<!--        <div class="text-c font-18 ">培训<span class="bold">付费卖家</span></div>-->
<!--        <div class="font-28 bold">10W+</div>-->
<!--      </li>-->
<!--      <li>-->
<!--        <img :src="`${imgURI}/static/index/IC4.png`"/>-->
<!--        <div class="text-c font-18">覆盖<span class="bold">卖家群体</span></div>-->
<!--        <div class="font-28 bold">70W+</div>-->
<!--      </li>-->
<!--      <li>-->
<!--        <img :src="`${imgURI}/static/index/IC5.png`"/>-->
<!--        <div class="text-c font-18">触达<span class="bold">行业用户</span>人次</div>-->
<!--        <div class="font-28 bold">2000W+ </div>-->
<!--      </li>-->
<!--    </ul>-->

    <div class="cross-border display-flex justify-content-center align-items-center">
      <div class="cross-border-left">
        <div class="display-flex align-items-end text-center justify-content-center" style="height: 200px;line-height: 34px;">
          <ul v-if="crossBorderIndex === 0" class="text-center color-FFFFFF font-18">
            <li>洞察跨境热点</li>
            <li>分享行业干货</li>
            <li>解读平台政策</li>
            <li>以潜心的态度考究每一篇推文</li>
            <li>做可信赖的跨境电商自媒体</li>
          </ul>
          <ul v-if="crossBorderIndex === 1" class="text-center color-FFFFFF font-18">
            <li>专注跨境电商行业发展</li>
            <li>定期分享行业干货好文</li>
            <li>甄选优质课程与服务工具</li>
            <li>为客户提供更专业的支持与服务</li>
            <li>卖家的一站式学习、交流平台</li>
          </ul>
          <ul v-if="crossBorderIndex === 2" class="text-center color-FFFFFF font-18">
            <li>行业资讯报道</li>
            <li>圈内事件见解</li>
            <li>明星讲师助阵</li>
            <li>定期干货直播</li>
          </ul>
        </div>
        <div class="display-flex justify-content-end">
          <img class="cursor-pointer" v-if="crossBorderIndex !== 0" @click="changeNum('left')" :src="`${imgURI}/static/index/JIANTOU1.png`">
        </div>
      </div>
      <div class="cross-border-right text-center">
        <div v-if="crossBorderIndex === 0">
          <div class="font-24 title">侃侃跨境那些事儿</div>
          <div class="display-flex justify-content-center">
            <div class="cross-border-right-one">
              <img :src="`${imgURI}/static/index/GZH.png`"/>
              <div class="font-16">公众号</div>
            </div>
            <div class="cross-border-right-one">
              <img :src="`${imgURI}/static/index/SPH.png`"/>
              <div class="font-16">视频号</div>
            </div>
          </div>
        </div>
        <div v-if="crossBorderIndex === 1">
          <div class="font-24 title">跨境电商侃侃网</div>
          <div class="display-flex justify-content-center">
            <div class="cross-border-right-one">
              <img :src="`${imgURI}/static/index/kankanwang.png`"/>
              <div class="font-16">公众号</div>
            </div>
          </div>
        </div>
        <div v-if="crossBorderIndex === 2">
          <div class="font-24 title">侃侃跨境电商学院</div>
          <div class="display-flex justify-content-center">
            <div class="cross-border-right-one">
              <img :src="`${imgURI}/static/index/douyin.png`"/>
              <div class="font-16">抖音号</div>
            </div>
            <div class="cross-border-right-one">
              <img :src="`${imgURI}/static/index/mossJS.png`"/>
              <div class="font-16">视频号</div>
            </div>
          </div>
        </div>
        <div style="display: flex;position: relative;top: -23.5px">
          <img class="cursor-pointer" v-if="crossBorderIndex !== 2" @click="changeNum('right')" :src="`${imgURI}/static/index/JIANTOU2.png`">
        </div>
      </div>
    </div>

<!--    更多服务-->
    <div class="more-tips display-flex justify-content-between items-center">
      <div>
        <div class="font-30 color-87898A">MORE</div>
        <div class="font-30 color-87898A">SERVICES</div>
        <div class="font-25 color-292C2E">更多服务<span class="tips-block"></span></div>
      </div>
      <div class="concept-bor display-flex align-items-center cursor-pointer">
        <div class="light-icon">
          <img :src="`${imgURI}/static/index/tubiao.png`"/>
        </div>
        <div @click="goTalent">
          <div class="font-20 color-292C2E">人才理念</div>
          <div class="font-12 color-87898A">TALENT CONCEPT</div>
        </div>
      </div>
    </div>
<!--    <div class="def-width moss-border display-flex justify-content-between margin-center">-->
<!--      <div>-->
<!--        <div class="title font-24">Moss的精神家园</div>-->
<!--        <ul>-->
<!--          <li class="display-flex">-->
<!--            <div class="line"></div>-->
<!--            <div class="ul-t font-18">侃侃&白鹿会创始人，畅销书作家</div>-->
<!--          </li>-->
<!--          <li class="display-flex">-->
<!--            <div class="line"></div>-->
<!--            <div class="ul-t font-18">澳洲悉尼大学经济学硕士，跨境电商行业TOP级运营顾问</div>-->
<!--          </li>-->
<!--          <li class="display-flex">-->
<!--            <div class="line"></div>-->
<!--            <div class="ul-t font-18">浙江大学中国跨境电子商务大讲堂专家讲师</div>-->
<!--          </li>-->
<!--          <li class="display-flex">-->
<!--            <div class="line"></div>-->
<!--            <div class="ul-t font-18">连续多年荣获跨境电商行业最具人气奖、突出贡献奖等荣誉</div>-->
<!--          </li>-->
<!--          <li class="display-flex">-->
<!--            <div class="line"></div>-->
<!--            <div class="ul-t font-18">代表著作:《跨境电商亚马逊是如何运营的&#45;&#45;从零做到年销千万实操手册》</div>-->
<!--          </li>-->
<!--        </ul>-->
<!--      </div>-->
<!--      <div>-->
<!--        <img :src="`${imgURI}/static/index/DOUYIN-M.png`">-->
<!--        <img class="img-2" :src="`${imgURI}/static/index/SHU.png`">-->
<!--      </div>-->
<!--    </div>-->

<!--    <div>-->
<!--      <div class="website-index-tips text-center">-->
<!--        <span class="tips-about bold">DEVELOPMENT HISTORY</span><span class="tips-block"></span>-->
<!--      </div>-->
<!--      <div class="website-index-tips-c text-center">发展历程</div>-->
<!--    </div>-->
<!--    <div class="development-bor def-width display-flex margin-center">-->
<!--      <ul class="year">-->
<!--        <li>2011</li>-->
<!--        <li>2014</li>-->
<!--        <li>2016</li>-->
<!--        <li>2017</li>-->
<!--        <li>2019</li>-->
<!--        <li>2020</li>-->
<!--        <li>2023</li>-->
<!--      </ul>-->
<!--      <div class="line"></div>-->
<!--      <ul class="msg display-flex">-->
<!--        <li class="display-flex align-items-center">-->
<!--          <div class="c"></div>-->
<!--          <div>于广州成立跨境电商公司，在速卖通、eBay等多个平台开展业务</div>-->
<!--        </li>-->
<!--        <li class="display-flex align-items-center">-->
<!--          <div class="c"></div>-->
<!--          <div>重点布局亚马逊平台，打造出多个爆款单品，创建国内最大的跨境电商论坛，单日UV破十万<br />-->
<!--            开展亚马逊培训40余场，培训跨境电商卖家2000余人次</div>-->
<!--        </li>-->
<!--        <li class="display-flex align-items-center">-->
<!--          <div class="c"></div>-->
<!--          <div>着力发展海外私域流量社群，积累海外私域粉丝超十万人，累计为超过800家跨境电商企业提供流量服务<br />-->
<!--            建立私域交流社群“小密圈”，同时为千位跨境电商卖家赋能</div>-->
<!--        </li>-->
<!--        <li class="display-flex align-items-center">-->
<!--          <div class="c"></div>-->
<!--          <div>“侃侃”品牌正式成立，并开设深圳公司，下辖三个跨境电商公众号粉丝数首年即突破50万<br />-->
<!--            “侃侃电商学院”新增四门专业课，年培训人次首次突破3000+</div>-->
<!--        </li>-->
<!--        <li class="display-flex align-items-center">-->
<!--          <div class="c"></div>-->
<!--          <div>全年连续召开10余场跨境电商千人峰会，先后举办广州美博会跨境专场、上海美博会跨境专场<br />-->
<!--            线上三大专题研究院成立，同时为超5000位卖家提供帮助</div>-->
<!--        </li>-->
<!--        <li class="display-flex align-items-center">-->
<!--          <div class="c"></div>-->
<!--          <div>全年组织开展跨境电商知识分享交流活动超100场，“侃侃大学”成立，开设八大专题课程，陪跑年度学员超1500人次<br />-->
<!--            持续为跨境电商企业提供资源型服务，累计服务企业超4000家</div>-->
<!--        </li>-->
<!--        <li class="display-flex align-items-center">-->
<!--          <div class="c"></div>-->
<!--          <div>侃侃新媒体全平台粉丝量破百万，全年累计开课超100场，培训跨境电商卖家超5000人次。线上直播跨境电商培训超60场，覆盖用户20W+<br />-->
<!--            全面升级“侃侃电商学院”，突破专题公开课模式，新增小班课、实操课、内训课、工作坊等</div>-->
<!--        </li>-->
<!--        <li class="display-flex align-items-center">-->
<!--          <div class="c"></div>-->
<!--          <div class="tips">未来可期</div>-->
<!--        </li>-->
<!--      </ul>-->
<!--    </div>-->
<!--    <div>-->
<!--      <div class="website-index-tips text-center">-->
<!--        <span class="tips-about bold">WONDERFUL REVIEW</span><span class="tips-block"></span>-->
<!--      </div>-->
<!--      <div class="website-index-tips-c text-center">精彩回顾</div>-->
<!--    </div>-->
<!--    <div class="website-carousel">-->
<!--      <el-carousel indicator-position="outside" :interval="4000" height="675px" :initial-index="initialIndex" @change="change">-->
<!--        <el-carousel-item v-for="(item, index) in videos" :key="index" :index="index">-->
<!--          <img :src="item.img" @click="goV(item)" class="aveter"/>-->
<!--          <img :src="`${imgURI}/static/index/play.png`" @click="goV(item)" class="v-play" v-if="initialIndex === index"/>-->
<!--        </el-carousel-item>-->
<!--      </el-carousel>-->
<!--    </div>-->
    <website-bot></website-bot>
  </div>
</template>

<script>
import WebsiteBot from '@/components/public/websiteBot'
import WebsiteHeader from '@/components/public/header'
import tips from '@/components/public/tips'
import config from '@/config/index'

export default {
  components: {WebsiteBot, WebsiteHeader, tips},
  name: 'websiteIndex',
  data () {
    return {
      crossBorderIndex: 0,
      crossBorderInterval: '',
      initialIndex: 0,
      videos: [
        {
          img: 'https://inkankan-1255390650.cos.ap-chengdu.myqcloud.com/web/1.png',
          url: 'https://inkankan-1255390650.cos.ap-chengdu.myqcloud.com/web/%E4%BE%83%E4%BE%83%E5%B9%B4%E7%BB%88%E5%A4%A7%E8%AF%BE%E5%9B%9E%E9%A1%BE%E8%A7%86%E9%A2%91.m4v'
        },
        {
          img: 'https://inkankan-1255390650.cos.ap-chengdu.myqcloud.com/web/2.jpg',
          url: 'https://inkankan-1255390650.cos.ap-chengdu.myqcloud.com/web/2023%E5%BC%80%E5%B9%B4%E5%A4%A7%E8%AF%BE.mp4'
        },
        {
          img: 'https://inkankan-1255390650.cos.ap-chengdu.myqcloud.com/web/3.jpg',
          url: 'https://inkankan-1255390650.cos.ap-chengdu.myqcloud.com/web/2022%E5%B9%B4%E7%BB%88%E5%A4%A7%E8%AF%BE.mp4'
        }
      ],
      imgURI: config.imgURI,
      serviceCardList: [
        {
          bg: 'kuajingzhonghegongju.png',
          title: '跨境综合工具',
          titleE: 'CROSS-BORDER INTEGRATED TOOL',
          content: '含侃侃直邮、Woot提报、广告代投等跨境综合服务工具可供选择。'
        },
        {
          bg: 'pinpaichuhaitu.png',
          title: '品牌出海',
          titleE: 'BRAND GOING TO SEA',
          content: '精准把握航线，构建传统企业出海“品牌力”，助力传统企业海外再升级。'
        },
        {
          bg: 'pinpaicehuatu.png',
          title: '品牌策划',
          titleE: 'BRAND PLANNING',
          content: '线上全媒体传播矩阵+线下高质量峰会，增塑品牌价值，精准抓取流量。'
        },
        {
          bg: 'dianshangxueyuantu.png',
          title: '电商学院',
          titleE: 'ELECTRICAL BUSINESS SCHOOL',
          content: '严选跨境业内具实操经验的重量级大咖组成师资团队，为客户定制全面多元化的课程服务；助力企业从业务场景到人才发展，一站式打造电商企业岗位专业胜任力模型。'
        }
      ]
    }
  },
  mounted () {
    // this.setCrossBorder()
  },
  beforeDestroy () {
  },
  methods: {
    goTalent () {

    },
    goMore () {
      this.$router.push('/about')
    },
    change (newIndex, oldIndex) {
      this.initialIndex = newIndex
    },
    goV (i) {
      window.open(i.url, '_blank')
    },
    changeNum (type) {
      switch (type) {
        case 'left':
          this.crossBorderIndex -= 1
          break
        case 'right':
          this.crossBorderIndex += 1
          break
      }
    },
    setCrossBorder () {
      this.crossBorderInterval = setInterval(() => {
        if (this.crossBorderIndex >= 2) {
          this.crossBorderIndex = 0
        } else {
          this.crossBorderIndex++
        }
      }, 3000)
    }
  }
}
</script>

<style lang="scss" scoped>
.website-index{
  .index-top{
    margin-top: -100px;
    width: 100%;
    height: 750px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    .index-top-bor{
      padding-top: 180px;
      margin: 0 auto;
      width: 1200px;
    }
    .tips{
      font-size: 25px;
      color: #ffffff;
    }
    .tips-c{
      letter-spacing: 8px;
      font-size: 48px;
      font-weight: bold;
      color: #ffffff;
    }
  }
  .data-bor{
    margin: 40px auto 0 auto;
    width: 1220px;
    height: 114px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .website-index-tips{
    padding: 89px 0 0 0;
  }
  .website-index-tips-c{
    padding-bottom: 60px;
    font-size: 24px;
  }
  .tips-about{
    letter-spacing: 2px;
    font-size: 25px;
  }
  .tips-block{
    position: relative;
    top: 2px;
    margin-left: 6px;
    display: inline-block;
    width: 12px;
    height: 12px;
    background: #0685D9;
    border-radius: 2px 2px 2px 2px;
  }
  .introduction-bor{
    margin: 40px auto 0 auto;
    width: 1200px;
    height: 700px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    font-size: 14px;
    .introduction-cont{
      color: #979797;
      margin-top: 30px;
      line-height: 24px;
    }
    .introduction-cont-2{
      color: #979797;
      margin-top: 16px;
    }
    .introduction-more{
      cursor: pointer;
      margin-top: 30px;
      text-align: center;
      padding: 4px 0;
      width: 80px;
      background: #4893e4;
      color: #FFFFFF;
      font-size: 12px;
    }
  }
  //.introduction{
  //  width: 543px;
  //  .introduction-c{
  //    margin-top: 6px;
  //    margin-right: 6px;
  //  }
  //  .introduction-line{
  //    margin-top: 3px;
  //    width: 36px;
  //    height: 2px;
  //    background: #386BF3;
  //    border-radius: 2px 2px 2px 2px;
  //  }

  //}
  .enterprise{
    margin-top: 70px;
  }
  .enterprise-msg{
    margin: 34px 0 34px 0;
  }
  .content-num{
    margin-top: 136px;
    .text-c{
      margin: 8px 0 6px 0;
    }
  }
  .cross-border{
    margin-top: 100px;
    width: 100%;
    height: 380px;
    background-image: url("/static/index/diwen2.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .cross-border-left{
      width: 458px;
      height: 240px;
      background: #0685D9;
      border: 1px solid #386BF3;
    }
    .cross-border-right{
      width: 458px;
      height: 240px;
      border: 1px solid #0685D9;
      .title{
        margin: 23px 0 8px 0;
      }
      .cross-border-right-one{
        height: 142px;
        padding: 10px;
        color: #919191;
      }
    }
  }
  .moss-border{
    margin-top: 122px;
    .line{
      position: relative;
      top: 8px;
      margin-right: 14px;
      width: 8px;
      height: 8px;
      background: #386BF3;
      border-radius: 2px 2px 2px 2px;
    }
    .title{
      margin-bottom: 23px;
    }
    .ul-t{
      margin-bottom: 15px;
    }
    .img-2{
      margin-left: 105px;
    }
  }
  .development-bor{
    margin-top: 122px;
    height: 800px;
    background-image: url("/static/index/diwen3.png");
    background-repeat: no-repeat;
    background-size: cover;
    .line{
      margin: -84px 59px 0 59px;
      width: 1px;
      height: 773px;
      background: linear-gradient( 180deg, #FFFFFF 0%, #BEBEBE 9%, #919191 100%);
    }
    .year{
      color: #FFFFFF;
      font-size: 18px;
      li{
        margin-bottom: 71px;
        width: 55px;
        height: 27px;
        line-height: 28px;
        background-image: url("/static/index/K.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        padding-left: 5px;
      }
    }
    .msg{
      flex-direction: column;
      font-size: 14px;
      li{
        line-height: 28px;
        margin-left: -64px;
      }
      .c{
        margin-right: 55px;
        border-radius: 50%;
        width: 9px;
        height: 9px;
        background: #386BF3;
      }
    }
    .msg li:nth-of-type(1){
      margin-top: 0;
    }
    .msg li:nth-of-type(2){
      margin-top: 56px;
    }
    .msg li:nth-of-type(3){
      margin-top: 42px;
    }
    .msg li:nth-of-type(4){
      margin-top: 42px;
    }
    .msg li:nth-of-type(5){
      margin-top: 42px;
    }
    .msg li:nth-of-type(6){
      margin-top: 42px;
    }
    .msg li:nth-of-type(7){
      margin-top: 42px;
    }
    .msg li:nth-of-type(8){
      margin-top: 42px;
    }
    .tips{
      font-size: 18px;
      color: #386BF3;
    }
  }
  .service-bg{
    margin-top: 117px;
    width: 100%;
    height: 747px;
    background: #F7FAFD;

    .service-card{
      width: 1000px;
      margin: 0 auto 0 auto;
      .service-item{
        box-shadow: 0 6px 10px #eaeaea;
        height: 340px;
        margin: 0 100px;
        //width: 321px;
        img{
          width: 100%;
          height: 173px;
        }

        .title-bor{
          margin: 0 20px;
          padding: 8px 0;
          border-bottom: 1px solid #707070;
        }

        .content-bor{
          margin: 0 20px;
          padding: 12px 0;
        }
      }
    }
  }

  .website-carousel{
    width: 1200px;
    margin: 58px auto 80px auto;
    .aveter{
      cursor: pointer;
      width: 100%;
      height: 100%;
    }
    .v-play{
      cursor: pointer;
      text-align: center;
      position: relative;
      left: 560px;
      top: -380px;
      width: 80px;
    }
  }
  .lg-bor{
    margin: 0 auto;
    width: 1200px;
    margin-bottom: 95px;
    img{
      width: 100%;
    }
  }

  .more-tips{
    padding: 100px 0;
    margin: 0 auto;
    width: 1200px;
    .tips-block{
      position: relative;
      top: 2px;
      margin-left: 6px;
      display: inline-block;
      width: 12px;
      height: 12px;
      background: #0685D9;
      border-radius: 2px 2px 2px 2px;
    }

    .concept-bor{
      box-shadow: 0 6px 10px #f1f1f1;
      padding: 20px 80px;
      gap: 24px;
      .light-icon{
        width: 57px;
        img{
          width: 100%;
        }
      }
    }
  }
}
</style>
<style>
.website-index .el-carousel__indicators--outside button {
  background-color: #386BF3;
  /*width: 60px;*/
  /*height: 6px;*/
}
/*.website-index .el-carousel__indicator--horizontal {*/
/*  display: inline-block;*/
/*  padding: 34px 13px;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/components/websiteIndex/index.vue